import { MenuItem } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"
import {
    fetchServiceCenterDeviceTemplates,
    ServiceCenterDeviceTemplatesResponse,
    ServiceCenterHomeQuery,
} from "../../../../../serviceCenter/report/home/serviceCenterHomeApi"
import { selectServiceCenterId } from "../../../../../login/loginSelectors"
import { useAppSelector } from "../../../../../store/storeHooks"

const selectTemplates = (data: ServiceCenterDeviceTemplatesResponse) => data.deviceTemplates

export function SelectDeviceTemplateDropdown() {
    const serviceCenterId = useAppSelector(selectServiceCenterId)

    const { data: deviceTemplates } = useApiQuery(fetchServiceCenterDeviceTemplates, {
        queryName: ServiceCenterHomeQuery.SERVICE_CENTER_DEVICE_TEMPLATES,
        dependencies: {
            serviceCenterId: serviceCenterId ?? 0,
        },
        select: selectTemplates,
    })

    return (
        <LocalizedStrict id="devices-create-or-edit-form-select-template-label" attrs={{ label: true }}>
            <FormikDropdown fullWidth name="templateId" label="Template*">
                {deviceTemplates?.map((device) => (
                    <MenuItem key={device.id} value={device.id}>
                        {device.type}
                    </MenuItem>
                ))}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
